/*
 * File: CustomAddTask.tsx
 * Project: a-a
 * File Created: Thursday, 20th February 2025 8:37:12 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 11th December 2025 9:42:19 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import {
  Box,
  Chip,
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
  Skeleton,
  Typography,
  useTheme,
} from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import CustomModal from '../CustomModal/CustomModal';
import CustomCard from '../CustomCard/CustomCard';
import zeplinColor from '../../../theme/Color';
import CustomButton from '../CustomButton/CustomButton';
import CustomDrawer from '../CustomDrawer/CustomDrawer';
import CustomAddTaskForm from './CustomAddTaskForm/CustomAddTaskForm';
import { useInput } from '../../../customHook/useInput';
import dayjs, { Dayjs } from 'dayjs';
import { SFService } from '../../../service/SF.service';
import CustomAlert from '../CustomAlert/CustomAlert';
import CustomAlertContain from '../CustomAlert/CustomAlertContain';
import validator from 'validator';
import { useLocation } from 'react-router-dom';
import { ClientService } from '../../../service/client.service';
import style from './CustomAddTask.module.css';
import CustomPlatformSelection from '../CustomPlatformSelection/CustomPlatformSelection';
import { HuddleDashboardService } from '../../../service/huddle-dashboard.service';
import { HuddleClientService } from '../../../service/huddle-client.service';

const CustomAddTask = ({
  handleContinueAdd,
  handleModalClose,
  modalOpen,
  setDrawerState,
  drawerState,
  edit,
  setEdit,
  data,
  setAdded,
  setEditDone,
  setTaskAnchorEl,
}: {
  handleContinueAdd: () => void;
  handleModalClose: () => void;
  modalOpen: boolean;
  setDrawerState: React.Dispatch<React.SetStateAction<boolean>>;
  drawerState: boolean;
  edit?: boolean;
  setEdit?: React.Dispatch<React.SetStateAction<boolean>>;
  data?: any;
  setAdded?: React.Dispatch<React.SetStateAction<boolean>>;
  setEditDone?: React.Dispatch<React.SetStateAction<boolean>>;
  setTaskAnchorEl?: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>;
}) => {
  const theme = useTheme();
  const location = useLocation();
  const sf_path = sessionStorage.getItem('sf_path') || '';
  let selectedMember: any = {};
  const storedMember = sessionStorage.getItem('selected-member');
  if (storedMember) {
    selectedMember = JSON.parse(storedMember);
  }
  const details = location.pathname?.split('/');
  const Email = sessionStorage.getItem('current-user') || '';
  const sf_token = sessionStorage.getItem('SFToken') || '';
  let parse_sf = {
    access_token: '',
    id: '',
    instance_url: '',
    issued_at: '',
    refresh_token: '',
    scope: '',
    signature: '',
    token_type: '',
  };
  if (sf_token) {
    parse_sf = JSON.parse(sf_token);
  }

  const [addSubTask, setAddSubTask] = useState(false);
  const [date, setDate] = useState<Dayjs | null>(
    dayjs(data?.dueDate).date() ? dayjs(data?.dueDate) : null,
  );
  const [dateSubtask, setDateSubtask] = useState<Dayjs | null>(null);
  const [alert, setAlert] = React.useState('');
  const OnClickSubTask = () => {
    setAddSubTask((prev) => !prev);
  };

  const [taskTypeSelected, setTaskTypeSelected] = useState(
    edit ? data?.recordTypeName : 'A&A Management Task',
  );
  const [selectedFiles, setSelectedFiles] = useState<File[]>(
    data?.attachments ? [...data?.attachments] : [],
  );
  const [attachments, setAttachments] = useState<{
    removed: string[];
    added: string[];
  }>({
    removed: [],
    added: [],
  });
  const uploadFile = async (data: any, contentType: string) => {
    try {
      const res = await SFService.uploadFile(data, contentType);
    } catch (err) {
      console.log(err);
    }
  };
  const onDrop = async (acceptedFiles: File[]) => {
    // Do something with the files

    setSelectedFiles((prev) => [...prev, ...acceptedFiles]);
    try {
      const getPresigned = await SFService.getPresigned(
        Email,
        acceptedFiles[0].type,
        acceptedFiles[0].name,
      );
      console.log(acceptedFiles[0]);
      const upload = await uploadFile(
        { ...getPresigned.fileds, file: acceptedFiles[0] },
        getPresigned.fileds['Content-Type'],
      );
      console.log({ getPresigned, upload });
      setAttachments((prev) => ({
        added: [...prev.added, `${getPresigned.url}${getPresigned.fileds.key}`],
        removed: [...prev.removed],
      }));
    } catch (err) {
      console.log(err);
    }
  };

  const handleDeleteFiles = (index: number) => {
    setSelectedFiles(selectedFiles?.filter((_, ind) => ind !== index));
    // setAttachments(attachments?.filter((_, ind) => ind !== index));
    setAttachments((prev) => ({
      added: attachments?.added?.filter((_, ind) => ind !== index),
      removed: edit
        ? [
            ...prev.removed,
            ...selectedFiles?.filter((_, ind) => ind === index).map((val) => val?.toString()),
          ]
        : [...prev.removed, ...attachments?.added?.filter((_, ind) => ind === index)],
    }));
  };
  const handleDeleteFilesSubtask = (index: number) =>
    setSelectedFiles(selectedFilesSubtask?.filter((_, ind) => ind !== index));
  const onDropSubtask = useCallback((acceptedFiles: File[]) => {
    // Do something with the files
    console.log(acceptedFiles);
    setSelectedFilesSubtask((prev) => [...prev, ...acceptedFiles]);
  }, []);
  const [error, setError] = useState('');
  const {
    handleChange: handleCommentChange,
    handleBlur: handleCommentBlur,
    clearInput: clearComment,
    value: comment,
    invalid: invalidComment,
    didChange: didCommentChange,
  } = useInput(data?.comments ? data?.comments : '', () => true);
  const {
    handleChange: handleTermsChange,
    handleBlur: handleTermsBlur,
    clearInput: clearTerms,
    value: terms,
    invalid: invalidTerms,
    didChange: didTermsChange,
  } = useInput(data?.terms ? data?.terms : '', () => true);
  const {
    handleChange: handleEmailChange,
    handleBlur: handleEmailBlur,
    clearInput: clearEmail,
    value: email,
    invalid: invalidEmail,
    didChange: didEmailChange,
  } = useInput(data?.email ? data?.email : '', validator.isEmail);
  const {
    handleChange: handleLinkChange,
    handleBlur: handleLinkBlur,
    clearInput: clearLink,
    value: link,
    invalid: invalidLink,
    didChange: didLinkChange,
  } = useInput(data?.inputLink ? data?.inputLink : '', () => true);
  const {
    handleChange: handlePayeeChange,
    handleBlur: handlePayeeBlur,
    clearInput: clearPayee,
    value: payee,
    invalid: invalidPayee,
    didChange: didPayeeChange,
  } = useInput(data?.payee ? data?.payee : '', () => true);
  const {
    handleChange: handleQTYChange,
    handleBlur: handleQTYBlur,
    clearInput: clearQTY,
    value: qTY,
    invalid: invalidQTY,
    didChange: didQTYChange,
  } = useInput(data?.qty ? data?.qty : '', () => true);
  const {
    handleChange: handleRateChange,
    handleBlur: handleRateBlur,
    clearInput: clearRate,
    value: rate,
    invalid: invalidRate,
    didChange: didRateChange,
  } = useInput(data?.rate ? data?.rate : '', () => true);
  const {
    handleChange: handleSubjectChange,
    handleBlur: handleSubjectBlur,
    clearInput: clearSubject,
    value: subject,
    invalid: invalidSubject,
    didChange: didSubjectChange,
  } = useInput(data ? data?.subject : '', () => true);

  const {
    handleChange: handleCommentSubtaskChange,
    handleBlur: handleCommentSubtaskBlur,
    clearInput: clearCommentSubtask,
    value: commentSubtask,
    invalid: invalidCommentSubtask,
    didChange: didCommentSubtaskChange,
  } = useInput('', () => true);
  const {
    handleChange: handleLinkSubtaskChange,
    handleBlur: handleLinkSubtaskBlur,
    clearInput: clearLinkSubtask,
    value: linkSubtask,
    invalid: invalidLinkSubtask,
    didChange: didLinkSubtaskChange,
  } = useInput('', () => true);
  const {
    handleChange: handleSubjectSubtaskChange,
    handleBlur: handleSubjectSubtaskBlur,
    clearInput: clearSubjectSubtask,
    value: subjectSubtask,
    invalid: invalidSubjectSubtask,
    didChange: didSubjectSubtaskChange,
  } = useInput('', () => true);

  const [subTask, setSubtask] = useState<
    {
      subject: string;
      comment: string;
      link: string;
    }[]
  >([]);
  const [selectedFilesSubtask, setSelectedFilesSubtask] = useState<File[]>([]);
  const [platformSelected, setPlatformSelected] = useState(
    (sf_token !== 'false' && sf_path) || (details[2] !== 'huddle' && details[1] === 'clients')
      ? 'Salesforce'
      : 'Huddle',
  );
  const [formLoading, setFormLoading] = useState(false);
  const addTask = async () => {
    try {
      setFormLoading(true);
      const props = {
        // access_token: parse_sf?.access_token,
        Subject: subject,
        OwnerId: selectedItems?.assignTo[0]?.Id,
        //  recordTypeName: taskTypeSelected,
        ...(date?.date() && { ActivityDate: date ? date : '' }),
        ...(comment && { Description: comment ? comment : '' }),
        // ...(selectedItems.related[0]?.Id && { whatId: selectedItems.related[0]?.Id }), // parse_sf?.access_token,
        ...(selectedItems.related[0]?.Id && { WhatId: selectedItems.related[0]?.Id }),
        // notes: comment,

        Status: Array.isArray(selectedItems.status)
          ? selectedItems.status[0]
          : selectedItems.status,
        Priority: Array.isArray(selectedItems.priority)
          ? selectedItems.priority[0]
          : selectedItems.priority,
        ...(selectedItems.name[0].Id && { WhoId: selectedItems.name[0].Id }),
        // ...(selectedItems.nameType && { nameType: selectedItems.nameType[0] }),
        ...(link && { GD_Link__c: link }),
        ...((attachments?.added?.length || attachments?.removed?.length) && {
          attachments: attachments,
        }),
        // noteContent: 'test note content',
        // noteTitle: 'test note title',
      };
      const addProps = {
        // access_token: parse_sf?.access_token,
        subject: subject,
        assignToId:
          location?.pathname?.includes('huddle') || platformSelected === 'Huddle'
            ? selectedItems?.assignTo[0]
            : selectedItems?.assignTo[0]?.Id,

        recordTypeName: taskTypeSelected,
        ...(date && { dueDate: date ? date : '' }),
        ...(comment && { comments: comment ? comment : '' }),
        ...(selectedItems.related[0]?.Id && {
          relatedToId:
            location?.pathname?.includes('huddle') || platformSelected === 'Huddle'
              ? selectedItems?.related[0]
              : selectedItems.related[0]?.Id,
        }),
        // notes: comment,
        ...(taskTypeSelected === 'Payment Task' && {
          ...(selectedItems?.payee[0]?.Id && { payeeId: selectedItems?.payee[0]?.Id }),
          ...(rate && { rate: +rate }),
          ...(qTY && { qty: +qTY }),
          ...(selectedItems?.terms[0] !== 'None' && { terms: selectedItems?.terms[0] }),
          ...(email && { email: email }),
        }),
        status: Array.isArray(selectedItems.status)
          ? selectedItems.status[0]
          : selectedItems.status,
        priority: Array.isArray(selectedItems.priority)
          ? selectedItems.priority[0]
          : selectedItems.priority,
        ...(selectedItems.name[0].Id && {
          name:
            location?.pathname?.includes('huddle') || platformSelected === 'Huddle'
              ? selectedItems?.name[0]
              : selectedItems.name[0].Id,
        }),
        ...(selectedItems.nameType[0] && { nameType: selectedItems.nameType[0] }),
        ...(link && { link: link }),
        ...((attachments?.added?.length || attachments?.removed?.length) && {
          attachments: attachments,
        }),
        // noteContent: 'test note content',
        // noteTitle: 'test note title',
      };
      const res = edit
        ? platformSelected === 'Huddle'
          ? await HuddleDashboardService.editHuddleTask(data?.id, props)
          : await SFService.editTask(data?.id, props)
        : platformSelected === 'Huddle'
        ? await HuddleDashboardService.createHuddleTasks(addProps)
        : await SFService.createTasks(addProps);

      sessionStorage.removeItem('sf_redirect');
      sessionStorage.removeItem('sf_edit');
      sessionStorage.removeItem('sf_delete');
      clearComment();
      clearLink();
      clearSubject();
      setDrawerState(false);
      setAdded && setAdded(true);
      setEdit && setEdit(false);
      setEditDone && setEditDone(true);
    } catch (err: any) {
      setAlert(err?.response?.data?.error);
    } finally {
      setFormLoading(true);
    }
  };

  const createSubtask = () => {
    setSubtask((prev) => [
      ...prev,
      {
        subject: subjectSubtask,
        comment: commentSubtask,
        link: linkSubtask,
        priority: selectedItemsSubtask.priority,
        status: selectedItemsSubtask.status,
      },
    ]);
    clearCommentSubtask();
    clearLinkSubtask();
    clearSubjectSubtask();
    clearEmail();
    clearQTY();
    clearRate();
    clearPayee();
    setSelectedFilesSubtask([]);
  };

  const [selectedItemsSubtask, setSelectedItemsSubtask] = useState<{
    priority: string[];
    status: string[];
    time: string[];
    client: string[];
  }>({
    priority: [],
    status: [],
    time: [],
    client: [],
  });
  const [loading, setLoading] = useState(false);
  const [assign, setAssign] = useState([{ Name: '', Id: '' }]);
  let Priority = ['Normal', 'Low', 'High'];
  let Status = ['In Progress', 'To Do', 'Done'];
  // let relatedType = ['Account', 'Deal'];
  // let Assign = [{ name: '', id: '' }];
  // let TimeRange = ['Day', 'Week', 'Month'];
  // let taskType = [''];

  // console.log(toDoLoading, inProgressLoading, doneLoading, 'total');

  //   const [drawerState, setDrawerState] = React.useState(false);
  const onClose = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    sessionStorage.removeItem('sf_path');
    sessionStorage.removeItem('sf_redirect');
    sessionStorage.removeItem('sf_edit');
    sessionStorage.removeItem('sf_delete');
    clearComment();
    clearLink();
    clearSubject();
    clearCommentSubtask();
    clearLinkSubtask();
    clearSubjectSubtask();
    clearEmail();
    clearQTY();
    clearRate();
    clearPayee();
    setDrawerState(open);
    setSelectedFiles([]);
    setSelectedFilesSubtask([]);
    setSelectedItems({
      priority: '',
      status: '',
      related: [],
      relatedType: [],
      assignTo: [],
      name: [],
      nameType: [],
      payee: [],
      dueDate: '',
      terms: [],
    });
    setSelectedItemsSubtask({
      priority: [],
      status: [],
      time: [],
      client: [],
    });
    setSubtask([]);
    setEdit && setEdit(false);
  };

  const [selectedClient, setSelectedClient] = React.useState<any>();
  const [recordType, setRecordType] = useState([
    'A&A Management Task',
    'Brick Media Task',
    'Payment Task',
  ]);
  const [selectedItems, setSelectedItems] = useState<{
    priority: string;
    status: string;
    related: { Name: string; Id: string }[];
    assignTo: { Name: string; Id: string }[];
    name: { Name: string; Id: string }[];
    payee: { Name: string; Id: string }[];
    nameType: string[];
    relatedType: string[];
    dueDate: string;
    terms: string[];
  }>({
    priority: data ? data?.priority : '',
    status:
      data?.status === 'Completed'
        ? 'Done'
        : data?.status === 'Not Started'
        ? 'To Do'
        : data?.status
        ? data?.status
        : '',
    related: data?.relatedTo?.Id
      ? [data?.relatedTo]
      : details[1] === 'clients'
      ? [{ Name: selectedClient?.accountName, Id: selectedClient?.accountId }]
      : [{ Name: '', Id: '' }],
    relatedType: data
      ? [data?.relatedToType?.toLocaleLowerCase()]
      : details[1] === 'clients'
      ? ['Account']
      : [''],
    name: data?.name?.Id ? [data?.name] : [{ Name: '', Id: '' }],
    payee: data?.payee?.Id
      ? [{ Name: data?.payee?.Name, Id: data?.payee.Id }]
      : [{ Name: '', Id: '' }],
    nameType: data ? [data?.nameType?.toLocaleLowerCase()] : [''],
    assignTo:
      details[1] === 'team'
        ? [{ Name: selectedMember?.name, Id: selectedMember?.id }]
        : data?.assignedTo?.Id
        ? [data?.assignedTo]
        : [{ Name: '', Id: '' }],
    dueDate: data ? data?.dueDate : '',
    terms: data?.terms ? [data?.terms] : [''],
  });
  const [relatedTo, setRelatedTo] = useState({
    account: [{ Name: '', Id: '' }],
    deal: [{ Name: '', Id: '' }],
  });
  const [name, setName] = useState({
    contact: [{ Name: '', Id: '' }],
    lead: [{ Name: '', Id: '' }],
  });

  const getDetails = async (id: string) => {
    setLoading(true);
    try {
      if (id) {
        const res =
          details[2] === 'huddle'
            ? await HuddleClientService.getClientHuddleDetails(id)
            : await ClientService.getClientDetails(id);

        setSelectedClient(res);
        setSelectedItems((prev) => ({
          ...prev,
          related: [{ Name: res?.accountName, Id: res?.accountId }],
        }));
      }
    } catch (err: any) {
      console.log(err, 'errdeal');
      setAlert(err?.message as string);
    } finally {
      setLoading(false);
    }
  };

  const getDropDown = async () => {
    setLoading(true);
    try {
      const res =
        platformSelected === 'Huddle' || details[2] === 'huddle'
          ? await HuddleDashboardService.getHuddleOptions(Email)
          : await SFService.getOptions(Email);
      // console.log(res);
      // setRecordType(res.recordTypes);
      // Priority = res.priority;
      setRelatedTo(res.relatedTo);
      setAssign(res.assignTo);
      setName(res.names);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (details?.length > 2 && details[2] === 'huddle') {
      getDetails(details[3]);
    } else if (details?.length > 2 && details[1] === 'clients') {
      getDetails(details[2]);
    }
  }, [details?.length]);
  console.log({ assign, recordType, relatedTo, location });

  const handleSelection = (item: any, type: string) => {
    const key = type as keyof typeof selectedItems;
    if (Array.isArray(item)) {
      setSelectedItems((prev) => ({ ...prev, [key]: [...item] }));
    } else if (item?.target?.value) {
      const {
        target: { value },
      } = item;

      setSelectedItems((prev) => ({
        ...prev,
        [key]: typeof value === 'string' ? value.split(',') : value,
      }));
    } else {
      setSelectedItems((prev) => ({
        ...prev,
        [key]: [item],
      }));
    }
  };

  const handleDeleteItems = (item: any, type: string) => {
    const key = type as keyof typeof selectedItems;

    // const {
    //   target: { value },
    // } = item;

    setSelectedItems({
      ...selectedItems,
      [key]: [...selectedItems.assignTo?.filter((val: any) => val !== item)],
    });
  };

  const handleSelectionSubtask = (item: any, type: string) => {
    const key = type as keyof typeof selectedItems;

    const {
      target: { value },
    } = item;

    setSelectedItemsSubtask({
      ...selectedItemsSubtask,
      [key]: typeof value === 'string' ? value.split(',') : value,
    });
  };
  const handleTaskType = (item: any) => {
    setTaskTypeSelected(item.target.value);
  };
  const handleClose = () => {
    setAlert('');
  };
  useEffect(() => {
    getDropDown();
  }, [edit]);

  return (
    <Box>
      <CustomModal handleClose={() => {}} open={modalOpen}>
        <Box
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}
        >
          <CustomCard
            styles={{
              borderRadius: '14px',
              padding: { xs: '16px', xl: '24px' },
              backgroundColor: zeplinColor.Neutral1,

              width: { xs: '280px', xl: '312px' },
              // height: '183px',
              boxShadow: 'rgba(0, 0, 0, 0.15)',
              // display: 'flex',
              // flexDirection: 'column',
              // justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '14px', xl: '24px' },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                  }}
                >
                  <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                    Create Task
                  </Typography>
                  <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
                    {details[1] !== 'clients'
                      ? 'Select where you want to create this task and choose its type.'
                      : ''}
                  </Typography>
                </Box>
                <img
                  src={'/assets/cross.svg'}
                  alt='logo'
                  className={style.icon}
                  onClick={handleModalClose}
                  style={{ cursor: 'pointer' }}
                />
              </Box>
              {setTaskAnchorEl && details[1] !== 'clients' && (
                <CustomPlatformSelection
                  sf_token={sf_token}
                  setPlatformSelected={setPlatformSelected}
                  platformSelected={platformSelected}
                  setAnchorEl={setTaskAnchorEl}
                />
              )}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: { xs: '10px', xl: '16px' },
                }}
              >
                <Typography variant='responsiveBody2' color={zeplinColor.BasicBlack}>
                  Select Task Type
                </Typography>
                <RadioGroup
                  aria-labelledby='demo-controlled-radio-buttons-group'
                  name='controlled-radio-buttons-group'
                  value={taskTypeSelected}
                  onChange={handleTaskType}
                  sx={{
                    color: zeplinColor.BasicBlack,
                    '&.Mui-checked': {
                      color: zeplinColor.BasicBlack,
                    },
                    padding: '0px',
                  }}
                >
                  {/* {loading ? (
                    <Skeleton
                      variant='text'
                      sx={{
                        fontSize: theme.typography.body2,
                        width: '100%',
                        // Optionally adjust other styles here
                      }}
                    />
                  ) : (
                    recordType.map((name) => (
                      <FormControlLabel
                        value={name}
                        control={
                          <Radio
                            sx={{
                              color: zeplinColor.BasicBlack,
                              '&.Mui-checked': {
                                color: zeplinColor.BasicBlack,
                              },
                            }}
                          />
                        }
                        label={name}
                        sx={{
                          color: zeplinColor.BasicBlack,
                          '& .MuiFormControlLabel-label': {
                            fontSize: { xs: '14px', xl: '16px' }, // Apply responsive font size to the label
                          },
                          '& .MuiButtonBase-root': {
                            fontSize: { xs: '14px', xl: '16px' },
                            color: zeplinColor.BasicBlack,
                            // border: `1px solid ${zeplinColor.BasicBlack}`,
                          },
                          padding: '0px',
                        }}
                      />
                    ))
                  )} */}
                  {recordType.map((name) => (
                    <FormControlLabel
                      value={name}
                      control={
                        <Radio
                          sx={{
                            color: zeplinColor.BasicBlack,
                            '&.Mui-checked': {
                              color: zeplinColor.BasicBlack,
                            },
                          }}
                        />
                      }
                      label={name}
                      sx={{
                        color: zeplinColor.BasicBlack,
                        '& .MuiFormControlLabel-label': {
                          fontSize: { xs: '14px', xl: '16px' }, // Apply responsive font size to the label
                        },
                        '& .MuiButtonBase-root': {
                          fontSize: { xs: '14px', xl: '16px' },
                          color: zeplinColor.BasicBlack,
                          // border: `1px solid ${zeplinColor.BasicBlack}`,
                        },
                        padding: '0px',
                      }}
                    />
                  ))}
                </RadioGroup>
              </Box>
              <CustomButton
                disabled={recordType[0] ? false : true}
                onClick={handleContinueAdd}
                variant='contained'
                // buttonVariant={'responsiveButtonMedium'}
                color={'primary'}
                style={{
                  width: '100%',
                  borderRadius: '14px',
                  height: 48,
                  padding: '14px 16px',
                  '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                }}
                textStyle={{ color: zeplinColor.Neutral1, fontSize: { xs: '14px', xl: '16px' } }}
                text={'Continue'}
                // tabindex={4}
              />
            </Box>
          </CustomCard>
          {/* {loading ? <CustomLoader /> : ''} */}
        </Box>
      </CustomModal>

      {drawerState && (
        <CustomDrawer state={drawerState} onClose={onClose(false)}>
          <Box
            sx={{ width: { xs: '427px', xl: '527px' }, position: 'relative', overflowY: 'scroll' }}
          >
            <Box
              sx={{
                position: 'sticky',
                top: 0,
                zIndex: 1000,
                backgroundColor: zeplinColor.Neutral1,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '40px 24px 24px 24px',
                }}
              >
                <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  {addSubTask ? (
                    <Box
                      sx={{
                        display: 'flex',
                        gap: '8px',
                        alignItems: 'center',
                        // justifyContent: 'space-between',
                        // padding: '40px 24px 24px 24px',
                      }}
                    >
                      <img
                        src={'/assets/arrow-left-blue.svg'}
                        className={style.icon}
                        alt='close'
                        style={{ cursor: 'pointer' }}
                        onClick={OnClickSubTask}
                      />
                      <Typography variant='responsiveHeading2'>Subtask</Typography>
                    </Box>
                  ) : edit ? (
                    <Typography variant='responsiveHeading2'>Edit Task</Typography>
                  ) : (
                    <Typography variant='responsiveHeading2'>
                      New Task: {taskTypeSelected}
                    </Typography>
                  )}
                  <Chip
                    label={
                      <Typography
                        variant='label1'
                        color={
                          details[1] === 'huddle' || platformSelected === 'Huddle'
                            ? zeplinColor.BasicBlack
                            : zeplinColor.Neutral1
                        }
                        sx={{
                          // textAlign: 'center',
                          // display: 'flex',
                          // justifyContent: 'center',
                          // alignItems: 'center',
                          textAlign: 'center',
                          display: 'block', // Changed from flex to block for proper ellipsis
                          maxWidth: '100%', // Ensure it takes full width of container
                          whiteSpace: 'nowrap', // Keep text on one line
                          overflow: 'hidden', // Hide overflow
                          textOverflow: 'ellipsis', // Show ellipsis
                        }}
                      >
                        {details[1] === 'huddle' ? 'Huddle' : platformSelected}
                      </Typography>
                    }
                    sx={{
                      // backgroundColor: zeplinColor.BasicBlack,
                      // padding: '5px 12px 5px 12px',
                      // borderRadius: '50px',
                      // // width: '50%',
                      // height: '24px',
                      backgroundColor:
                        details[1] === 'huddle' || platformSelected === 'Huddle'
                          ? zeplinColor.Brand2
                          : zeplinColor.Blue,
                      padding: '5px 12px 5px 12px',
                      borderRadius: '50px',
                      height: '24px',
                      maxWidth: '100%', // Allow chip to take full width available
                      '& .MuiChip-label': {
                        // Target the inner label directly
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        display: 'block',
                        maxWidth: '120px', // Adjust this value as needed
                      },
                    }}
                  />
                </Box>
                {!addSubTask && (
                  <img
                    src={'/assets/close-icon.svg'}
                    className={style.icon}
                    alt='close'
                    style={{ cursor: 'pointer' }}
                    onClick={
                      edit
                        ? () => {
                            setEdit && setEdit(false);
                            sessionStorage.removeItem('sf_path');
                          }
                        : onClose(false)
                    }
                  />
                )}
              </Box>

              <Divider
                component='div'
                sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }}
              />
            </Box>
            {/* {addSubTask ? (
            <CustomAddTaskForm
              subtask={addSubTask}
              OnClickSubtask={OnClickSubTask}
              handleCommentChange={handleCommentSubtaskChange}
              handleCommentBlur={handleCommentSubtaskBlur}
              comment={commentSubtask}
              invalidComment={invalidCommentSubtask}
              didCommentChange={didCommentSubtaskChange}
              handleLinkChange={handleLinkSubtaskChange}
              handleLinkBlur={handleLinkSubtaskBlur}
              link={linkSubtask}
              invalidLink={invalidLinkSubtask}
              didLinkChange={didLinkSubtaskChange}
              handleSubjectChange={handleSubjectSubtaskChange}
              handleSubjectBlur={handleSubjectSubtaskBlur}
              subject={subjectSubtask}
              invalidSubject={invalidSubjectSubtask}
              didSubjectChange={didSubjectSubtaskChange}
              error={error}
              Priority={Priority}
              Status={Status}
              selectedItems={selectedItemsSubtask}
              handleSelection={handleSelectionSubtask}
              onDrop={onDropSubtask}
              selectedFiles={selectedFilesSubtask}
              add={createSubtask}
              deleteFile={handleDeleteFilesSubtask}
              selectedType={taskTypeSelected}
              handlePayeeChange={handlePayeeChange}
              handlePayeeBlur={handlePayeeBlur}
              payee={payee}
              invalidPayee={invalidPayee}
              didPayeeChange={didPayeeChange}
              handleRateChange={handleRateChange}
              handleRateBlur={handleRateBlur}
              rate={rate}
              invalidRate={invalidRate}
              didRateChange={didRateChange}
              handleQTYChange={handleQTYChange}
              handleQTYBlur={handleQTYBlur}
              qTY={qTY}
              invalidQTY={invalidQTY}
              didQTYChange={didQTYChange}
              handleEmailChange={handleEmailChange}
              handleEmailBlur={handleEmailBlur}
              email={email}
              invalidEmail={invalidEmail}
              didEmailChange={didEmailChange}
              handleTermsChange={handleTermsChange}
              handleTermsBlur={handleTermsBlur}
              terms={terms}
              invalidTerms={invalidTerms}
              didTermsChange={didTermsChange}
              date={dateSubtask}
              setDate={setDateSubtask}
            />
          ) : ( */}

            <CustomAddTaskForm
              subtask={addSubTask}
              OnClickSubtask={OnClickSubTask}
              payee={payee}
              handlePayeeChange={handlePayeeChange}
              handlePayeeBlur={handlePayeeBlur}
              invalidPayee={invalidPayee}
              didPayeeChange={didPayeeChange}
              rate={rate}
              didRateChange={didRateChange}
              handleRateChange={handleRateChange}
              invalidRate={invalidRate}
              handleRateBlur={handleRateBlur}
              handleQTYChange={handleQTYChange}
              handleQTYBlur={handleQTYBlur}
              qTY={qTY}
              didQTYChange={didQTYChange}
              invalidQTY={invalidQTY}
              handleCommentChange={handleCommentChange}
              handleCommentBlur={handleCommentBlur}
              comment={comment}
              invalidComment={invalidComment}
              didCommentChange={didCommentChange}
              handleLinkChange={handleLinkChange}
              handleLinkBlur={handleLinkBlur}
              link={link}
              invalidLink={invalidLink}
              didLinkChange={didLinkChange}
              handleSubjectChange={handleSubjectChange}
              handleSubjectBlur={handleSubjectBlur}
              subject={subject}
              invalidSubject={invalidSubject}
              didSubjectChange={didSubjectChange}
              error={error}
              Priority={Priority}
              Status={Status}
              selectedItems={selectedItems}
              handleSelection={handleSelection}
              onDrop={onDrop}
              selectedFiles={selectedFiles}
              add={() => {
                addTask();
              }}
              deleteFile={handleDeleteFiles}
              selectedType={taskTypeSelected}
              subTask={subTask}
              date={date}
              setDate={setDate}
              handleDeleteItems={handleDeleteItems}
              Assign={assign}
              relatedTo={relatedTo}
              name={name}
              edit={edit ? true : false}
              key={assign[0].Id}
              email={email}
              handleEmailChange={handleEmailChange}
              handleEmailBlur={handleEmailBlur}
              didEmailChange={didEmailChange}
              invalidEmail={invalidEmail}
              formLoading={formLoading}
              setFormLoading={setFormLoading}
            />
          </Box>
        </CustomDrawer>
      )}

      <CustomAlert
        open={alert ? true : false}
        handleClose={handleClose}
        message={
          <CustomAlertContain
            alert={alert}
            alertIcon={<img src='/assets/error.svg' width={24} height={24} />}
            error={alert ? true : false}
          />
        }
        error={alert ? true : false}
      />
    </Box>
  );
};

export default CustomAddTask;
